







  import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"ChangePassword"
})
export default class Profil extends Vue {}
